import { FormInputMeta } from '@Modules/core/types/FormMetaType';
import { getValidationSchema } from '@Shared/utils/validationSchema';
import * as yup from "yup";


export interface IMemoFormMeta {
    start: FormInputMeta;
    memo: FormInputMeta;
    dateActiv: FormInputMeta;
    datePurge: FormInputMeta;
    expirationDate: FormInputMeta;
    schema: any;
  }

const MemoFormMeta = {} as IMemoFormMeta;

MemoFormMeta.start = {
  name: "start",
  label: "De",
  type: "text",
  validation: yup.string().required(),
}
MemoFormMeta.memo = {
  name: "memo",
  label: "Memo",
  type: "text",
  validation: yup.string().required(),
}
MemoFormMeta.dateActiv = {
  name: "dateActiv",
  label: "Date Activ.",
  type: "date",
  validation: yup.string().required(),
}
MemoFormMeta.datePurge = {
  name: "datePurge",
  label: "Date Purge",
  type: "date",
  validation: yup.string().required(),
}
MemoFormMeta.expirationDate = {
  name: "expirationDate",
  label: "Date Expir.",
  type: "date",
  validation: yup.string().required(),
}



MemoFormMeta.schema = yup.object().shape(getValidationSchema(MemoFormMeta));

export default MemoFormMeta;